// extracted by mini-css-extract-plugin
module.exports = {"link":"ResetPassword_link__3lXGD"};